const apiUrl = process.env.REACT_APP_API_URL;

export const SEND_CONTACT_US_MESSAGE = `${apiUrl}/contact-us`;
export const SEND_CAREERS_MESSAGE = `${apiUrl}/careers`;
